export class Common {

    public static openActionsBehaviour () {
        const fixed_action_btn = $('.fixed-action-btn');
        if (fixed_action_btn.length == 0) {
            return;
        }
        const btn = fixed_action_btn.find('.btn-floating');
        const close = fixed_action_btn.find('.close');

        btn.on("click", function () {
            const buttons_open = $(this).closest('.fixed-action-btn').find('.buttons');
            buttons_open.addClass("visible");
        });

        close.on("click", function () {
            const buttons_close = $(this).closest('.fixed-action-btn').find('.buttons');
            buttons_close.removeClass("visible");
        });
    }

    public static _openDesplegableFichaRopa() {
        const $body = $('body');
        const $description = $body.find('.info__product-container');

        if((!$body.hasClass('node-ropa') && !$body.hasClass('page-product')) || $description.length == 0){
            return;
        }

        const $textContainer = $description.find('.info__product, .info_usos');
        const $toggleButton = $description.find('.show-more');

        if($textContainer?.height() <= 104){
            $toggleButton.remove();
            $textContainer.addClass('not-line-clamp');
        }

        $toggleButton.on('click', function (){
            $textContainer.toggleClass('open');
        });
    }
}
